import Hero from "./components/Hero";
import Collection from "./components/Collection";
import PerfectMatch from "./components/PerfectMatch";
import ShopNav from "@/components/feature/ShopNav";

export default function Home() {
  return (
    <main style={{ background: "#EEEAE3" }}>
      <ShopNav variant="light" />
      <Hero />
      <Collection />
      <PerfectMatch />
    </main>
  );
}